/**
 * Created by staffanrantzow on 21/03/16.
 */

/* @flow */
import React from 'react';
import Translate from 'react-translate-component';

export class NewsList extends React.Component {

  loadHostedNewsRoom () {
    if (!document
      .querySelectorAll('script[src="//frilans-finans-sverige-ab.mynewsdesk.com/hosted_newsroom.js"]')
      .length) {
      var s=document.createElement('script');
      s.type='text/javascript';
      s.async=true;
      s.src='//frilans-finans-sverige-ab.mynewsdesk.com/hosted_newsroom.js';
      var i=document.getElementsByTagName('script')[0];
      i.parentNode.insertBefore(s, i);
    }
  }

  createMarkup (html) {
    return {__html: html};
  }

  render () {
    return (
      <div className='row'>
        <div className='col-sm-12'>
          <div className='news-list-wrapper'>
            <h2><Translate content='NEWS'/></h2>
            <ul className='news-list'>
              <script type="text/javascript" charSet="utf-8" id="mnd-script">
                {this.loadHostedNewsRoom()}
              </script>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default NewsList;



/** WEBPACK FOOTER **
 ** ./src/views/news-list/news-list.js
 **/